<template>
  <div>
    <div class="streams-title-row subtitle">
      Logs
    </div>
    <el-table
        class="logTableInAdmin"
        :row-class-name="tableRowClassName"
        :data="pagedTableData"
        style="width: 100%; max-height: 720px; overflow: scroll;"
    >
      <el-table-column prop="date" :formatter="dateToUTC" label="Date"> </el-table-column>
      <el-table-column prop="userId" label="User Id"> </el-table-column>
      <el-table-column prop="actionName" label="Action"> </el-table-column>
      <el-table-column
          :style="{'white-space': 'pre-wrap'}"
          prop="actionParameters.stream"
          label="Stream"
      >
      </el-table-column>
    </el-table>
    <el-pagination layout="prev, pager, next" :total="logInfo.length" @current-change="setPage">
    </el-pagination>
  </div>
</template>

<script>
import { actionsLog } from "@/api/servers.js";
export default {
  data() {
    return {
      logInfo: [],
      page: 1,
      pageSize: 7
    };
  },
  async mounted() {
    const updateListLog = async () => {
      this.logInfo = await actionsLog();
    };
    setInterval(() => updateListLog(), 3000);
  },
  computed: {
    pagedTableData() {
      return this.logInfo.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page)
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      return rowIndex >= 0 ? "success-row" : "success-row";
    },
    dateToUTC(row,column){
      return  new Date(row.date).toString()
    },
    setPage(val) {
      this.page = val;
    }
  }
};
</script>
<style>
.el-table .warning-row {
  color: black;
  background: #ffffff;

}

.el-table .success-row {
  color: black;
  background: #ffffff;
}

.el-table .success-row:hover {
  color: black;
  background: #ffffff;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #ffffff;
}

.el-table--enable-row-transition .el-table__body td:last-child >.cell {
  white-space: pre-wrap;
  line-height: 1.1em;
  font-family: monospace;
  max-height: 200px;
}

.el-table::-webkit-scrollbar {
  width: 0;
}

.active {
  color: #409EFF !important;
  cursor: default;
}

</style>
<style scoped>
.streams-list {
  display: flex;
  flex-direction: column;
}
.streams-title-row {
  padding-bottom: 1em;
}
</style>